import { InjectionToken } from '@angular/core';

export const SDK_CONFIG_TOKEN = new InjectionToken('SDK_LIB_CONFIG');
